(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// Theme
//
// ------------------------------------



(function($) {

	if (typeof window.Video == 'undefined') window.Video = {};

	Video = {

		videos: [],


		/*
		 * Theme init
		 */

		init: function() {

			// Guard
            if($('[data-youtube-video-id]').length > 0) this.loadYouTube();

		},

        loadYouTube(){

            var tag = document.createElement('script');
	        tag.src = "https://www.youtube.com/iframe_api";
	        var firstScriptTag = document.getElementsByTagName('script')[0];
	        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        },

		onYouTubeReady(){
			console.log("VIDEO");

			var video_id = $('[data-youtube-video-id]').data('youtubeVideoId');

			player = new YT.Player('headervideo', {
	            // height: '390',
	            // width: '640',
	            // videoId: video_id,
	  		  	// playerVars: { 'controls': 0, 'loop': 1, 'rel':0 },
	            events: {
	              'onReady': Video.onYouTubePlayerReady,
	              'onStateChange': Video.onYouTubePlayerStateChange
	            }
	          });

		},

		onYouTubePlayerReady(event){
			// console.log("Player Read");
			// console.log(event);
			// event.target.setVolume(0);
			event.target.playVideo();
		},


		onYouTubePlayerStateChange(event){

			// console.log("STATE CHANGE");
		}


	};

	module.exports = Video;

})(jQuery);

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/video.js","/modules")